import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

// Images backfilled by loopbuild-api's scripts/backfill-material-images.ts land under
// this path in the material-images bucket. They were found by web search, matched to the
// product by a model, and attached to a *family* of SKUs — so the photo may show another
// size or finish from the same line, and it is not the seller's own photography.
// Catalogue imagery ingested from supplier PDFs sits under other prefixes in the same
// bucket (fittings/, ...) and gets no disclaimer.
//
// Keyed off the URL rather than a database column on purpose: the write path already
// encodes provenance in the path, so there is nothing to keep in sync and no migration.
const BACKFILL_PATH = '/material-images/family/';

const isBackfilledImage = image =>
  Object.values(image?.attributes?.variants || {}).some(v =>
    (v?.url || '').includes(BACKFILL_PATH)
  );

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  const showIllustrativeNote = (images || []).some(isBackfilledImage);
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
      {showIllustrativeNote ? (
        <p className={css.illustrativeImageNote}>
          <FormattedMessage id="ListingPage.illustrativeImageNote" />
        </p>
      ) : null}
    </section>
  );
};

export default SectionGallery;
